module.exports = __webpack_public_path__ + "static/media/Pallavi Buwa.0a387837.jpg";